import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Orbit, X } from "lucide-react";
import { SectionHead } from "./Reveal";
import PanoViewer from "./PanoViewer";

const DEMO_PANO =
    "https://images.unsplash.com/photo-1742844552699-2fb71ad66a72?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHwxfHxlcXVpcmVjdGFuZ3VsYXIlMjAzNjAlMjBwYW5vcmFtYSUyMGludGVyaW9yJTIwbW9kZXJuJTIwbHV4dXJ5JTIwbG9iYnklMjByb29tJTIwYXJjaGl0ZWN0dXJlfGVufDB8fHx8MTc4OTAyNjE3Nnww&ixlib=rb-4.1.0&q=85&w=3600&h=1800&fit=crop";

const CATEGORIES = [
    "All",
    "Hotels",
    "Restaurants",
    "Showrooms",
    "Real Estate",
    "Offices",
    "Schools",
    "Hospitals",
    "Industries",
];

const IMG = {
    Hotels: "https://images.unsplash.com/photo-1747380755783-61befe9b3da7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHwzfHxsdXh1cnklMjBpbnRlcmlvciUyMGFyY2hpdGVjdHVyZSUyMDM2MCUyMHBhbm9yYW1hJTIwaG90ZWwlMjBzaG93cm9vbSUyMHJlYWwlMjBlc3RhdGV8ZW58MHx8fHwxNzg5MDI2MTY5fDA&ixlib=rb-4.1.0&q=85&w=900",
    Restaurants: "https://images.unsplash.com/photo-1733413788595-ab2e2e8c0a9c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHwyfHxsdXh1cnklMjBpbnRlcmlvciUyMGFyY2hpdGVjdHVyZSUyMDM2MCUyMHBhbm9yYW1hJTIwaG90ZWwlMjBzaG93cm9vbSUyMHJlYWwlMjBlc3RhdGV8ZW58MHx8fHwxNzg5MDI2MTY5fDA&ixlib=rb-4.1.0&q=85&w=900",
    Showrooms: "https://images.unsplash.com/photo-1630703125102-ba2c078309d9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHw0fHxlcXVpcmVjdGFuZ3VsYXIlMjAzNjAlMjBwYW5vcmFtYSUyMGludGVyaW9yJTIwbW9kZXJuJTIwbHV4dXJ5JTIwbG9iYnklMjByb29tJTIwYXJjaGl0ZWN0dXJlfGVufDB8fHx8MTc4OTAyNjE3Nnww&ixlib=rb-4.1.0&q=85&w=900",
    "Real Estate": "https://images.unsplash.com/photo-1760072513357-9d450e935a80?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBpbnRlcmlvciUyMGFyY2hpdGVjdHVyZSUyMDM2MCUyMHBhbm9yYW1hJTIwaG90ZWwlMjBzaG93cm9vbSUyMHJlYWwlMjBlc3RhdGV8ZW58MHx8fHwxNzg5MDI2MTY5fDA&ixlib=rb-4.1.0&q=85&w=900",
    Offices: "https://images.unsplash.com/photo-1742844552699-2fb71ad66a72?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHwxfHxlcXVpcmVjdGFuZ3VsYXIlMjAzNjAlMjBwYW5vcmFtYSUyMGludGVyaW9yJTIwbW9kZXJuJTIwbHV4dXJ5JTIwbG9iYnklMjByb29tJTIwYXJjaGl0ZWN0dXJlfGVufDB8fHx8MTc4OTAyNjE3Nnww&ixlib=rb-4.1.0&q=85&w=900",
    Schools: "https://images.unsplash.com/photo-1686100510516-57fca1d59cbc?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHwzfHxlcXVpcmVjdGFuZ3VsYXIlMjAzNjAlMjBwYW5vcmFtYSUyMGludGVyaW9yJTIwbW9kZXJuJTIwbHV4dXJ5JTIwbG9iYnklMjByb29tJTIwYXJjaGl0ZWN0dXJlfGVufDB8fHx8MTc4OTAyNjE3Nnww&ixlib=rb-4.1.0&q=85&w=900",
    Hospitals: "https://images.unsplash.com/photo-1761971975769-97e598bf526b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTF8MHwxfHNlYXJjaHwzfHxtb2Rlcm4lMjBsdXh1cnklMjBob3RlbCUyMHJlc3RhdXJhbnQlMjBpbnRlcmlvciUyMGZpdG5lc3MlMjBneW0lMjBmYWN0b3J5JTIwc2hvd3Jvb20lMjBob3NwaXRhbCUyMG9mZmljZXxlbnwwfHx8fDE3ODkwMjYxNzZ8MA&ixlib=rb-4.1.0&q=85&w=900",
    Industries: "https://images.unsplash.com/photo-1761971975651-4fdd4abc200f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTF8MHwxfHNlYXJjaHw0fHxtb2Rlcm4lMjBsdXh1cnklMjBob3RlbCUyMHJlc3RhdXJhbnQlMjBpbnRlcmlvciUyMGZpdG5lc3MlMjBneW0lMjBmYWN0b3J5JTIwc2hvd3Jvb20lMjBob3NwaXRhbCUyMG9mZmljZXxlbnwwfHx8fDE3ODkwMjYxNzZ8MA&ixlib=rb-4.1.0&q=85&w=900",
};

const PROJECTS = CATEGORIES.slice(1).map((cat) => ({
    category: cat,
    title: `${cat} Signature Tour`,
    img: IMG[cat],
}));

export default function Portfolio() {
    const [active, setActive] = useState("All");
    const [preview, setPreview] = useState(null);

    const filtered =
        active === "All" ? PROJECTS : PROJECTS.filter((p) => p.category === active);

    return (
        <section id="portfolio" className="relative py-20 lg:py-32" data-testid="portfolio-section">
            <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
                <SectionHead
                    chapter="11"
                    eyebrow="Portfolio"
                    title="EXPERIENCE OUR WORK"
                    sub="Sample tours across every kind of space — filter by industry and step inside a live 360° preview."
                />

                <div className="mt-10 flex flex-wrap gap-2.5" data-testid="portfolio-filters">
                    {CATEGORIES.map((c) => (
                        <button
                            key={c}
                            data-testid={`filter-${c.toLowerCase().replace(/\s+/g, "-")}`}
                            onClick={() => setActive(c)}
                            className={`rounded-full px-5 py-2.5 text-xs font-semibold uppercase tracking-[0.15em] transition-all duration-300 ${
                                active === c
                                    ? "bg-[#00C6FF] text-[#050B14]"
                                    : "border border-[#00C6FF]/30 text-slate-300 hover:border-[#00C6FF]/60 hover:text-[#00C6FF]"
                            }`}
                        >
                            {c}
                        </button>
                    ))}
                </div>

                <motion.div layout className="mt-10 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">
                    <AnimatePresence mode="popLayout">
                        {filtered.map((p, i) => (
                            <motion.div
                                layout
                                key={p.category}
                                data-testid={`portfolio-card-${p.category.toLowerCase().replace(/\s+/g, "-")}`}
                                initial={{ opacity: 0, scale: 0.94 }}
                                animate={{ opacity: 1, scale: 1 }}
                                exit={{ opacity: 0, scale: 0.94 }}
                                transition={{ duration: 0.45, delay: i * 0.04 }}
                                className="group relative h-72 overflow-hidden rounded-2xl border border-[#00C6FF]/20"
                            >
                                <img
                                    src={p.img}
                                    alt={p.title}
                                    loading="lazy"
                                    className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 group-hover:scale-110"
                                />
                                <div className="absolute inset-0 bg-gradient-to-t from-[#050B14] via-transparent to-transparent" />
                                <span className="absolute right-4 top-4 flex h-10 w-10 items-center justify-center rounded-full border border-[#00C6FF]/50 bg-[#050B14]/70 text-[#00C6FF] backdrop-blur-md transition-transform duration-500 group-hover:rotate-[360deg]">
                                    <Orbit size={18} />
                                </span>
                                <div className="absolute inset-x-0 bottom-0 p-5">
                                    <p className="font-mono-accent text-[10px] uppercase tracking-[0.3em] text-[#00C6FF]">
                                        {p.category}
                                    </p>
                                    <h3 className="mt-1 font-semibold text-white">{p.title}</h3>
                                    <button
                                        data-testid={`portfolio-explore-${p.category.toLowerCase().replace(/\s+/g, "-")}`}
                                        onClick={() => setPreview(p)}
                                        className="mt-3 rounded-full bg-[#00C6FF] px-4 py-2 text-[10px] font-bold uppercase tracking-[0.15em] text-[#050B14] opacity-0 transition-all duration-300 group-hover:opacity-100"
                                    >
                                        Explore 360°
                                    </button>
                                </div>
                            </motion.div>
                        ))}
                    </AnimatePresence>
                </motion.div>
            </div>

            <AnimatePresence>
                {preview && (
                    <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        exit={{ opacity: 0 }}
                        className="fixed inset-0 z-[70] flex items-center justify-center bg-[#050B14]/90 p-4 backdrop-blur-md"
                        onClick={() => setPreview(null)}
                        data-testid="portfolio-modal"
                    >
                        <motion.div
                            initial={{ opacity: 0, y: 40, scale: 0.96 }}
                            animate={{ opacity: 1, y: 0, scale: 1 }}
                            exit={{ opacity: 0, y: 40, scale: 0.96 }}
                            transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
                            onClick={(e) => e.stopPropagation()}
                            className="w-full max-w-4xl"
                        >
                            <div className="mb-4 flex items-center justify-between">
                                <div>
                                    <p className="font-mono-accent text-[10px] uppercase tracking-[0.3em] text-[#00C6FF]">
                                        {preview.category} · Demo Preview
                                    </p>
                                    <h3 className="text-xl font-bold text-white">{preview.title}</h3>
                                </div>
                                <button
                                    data-testid="portfolio-modal-close"
                                    onClick={() => setPreview(null)}
                                    className="rounded-full border border-[#00C6FF]/30 p-2.5 text-slate-300 hover:text-[#00C6FF]"
                                    aria-label="Close preview"
                                >
                                    <X size={18} />
                                </button>
                            </div>
                            <PanoViewer
                                image={DEMO_PANO}
                                testIdPrefix="portfolio-pano"
                                heightClass="h-[60vh] min-h-[380px]"
                            />
                        </motion.div>
                    </motion.div>
                )}
            </AnimatePresence>
        </section>
    );
}
